import React from 'react';
import { Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslations } from '../context/TranslationContext';

const Footer: React.FC = () => {
  const { t } = useTranslations();
  return (
    <footer className="py-16 md:py-20 bg-deep-space text-gray-300 border-t border-white/10">
      <div className="container mx-auto px-6 md:px-12 max-w-7xl flex flex-col md:flex-row justify-between items-start md:items-end">
        <div className="mb-12 md:mb-0 text-left">
          <div className="text-2xl font-bold text-white mb-6 tracking-tight">
            LEGISRATIO
          </div>
          <div className="text-base leading-relaxed text-gray-400">
            <p>Piazzale Lavater, 3</p>
            <p>{t('footer_city')}</p>
            <p>C.F./P.IVA 14027540963</p>
            <p className="mt-3">
              <a href="https://startup.registroimprese.it/isin/dettaglioStartup?id=KXU3bCJQBfS92AJOXqJVKg%2BWNu3uDSQnxKwuUw3how%3D%3D" target="_blank" rel="noopener noreferrer" className="hover:text-mystic-violet transition-colors">
                {t('footer_company_registry')}
              </a>
            </p>
            <p className="mt-6 text-gray-400">&copy; 2025 LegisRatio S.R.L.</p>
            <p className="text-gray-400">{t('footer_all_rights_reserved')}</p>
            <p className="mt-4 text-gray-400">
              {t('footer_grant_notice')}
            </p>
          </div>
        </div>

        <div className="flex flex-col items-start md:items-end space-y-8">
          <ul className="flex space-x-6">
            <li>
              <a target="_blank" href="mailto:info@legisratio.it" rel="noopener noreferrer" className="text-gray-300 hover:text-mystic-violet transition-colors duration-200">
                <Mail className="w-7 h-7" />
              </a>
            </li>
          </ul>
          <div className="flex flex-col space-y-2 text-base md:flex-row md:space-x-6 md:space-y-0">
            <a href="https://www.iubenda.com/privacy-policy/81863162" className="iubenda-black iubenda-noiframe iubenda-embed iubenda-noiframe text-gray-400 hover:text-mystic-violet transition-colors duration-200" title="Privacy Policy ">
              Privacy Policy
            </a>
            <a href="https://www.iubenda.com/privacy-policy/81863162/cookie-policy" className="iubenda-black iubenda-noiframe iubenda-embed iubenda-noiframe text-gray-400 hover:text-mystic-violet transition-colors duration-200" title="Cookie Policy ">
              Cookie Policy
            </a>
            <Link to="/terms" className="text-gray-400 hover:text-mystic-violet transition-colors duration-200">{t('terms_link')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
